import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

import API from "@dndUtilities/system_api";

import StringBox from "@components/input/strings/StringBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";

interface Props {
  character: Character;
}

const api = API.getInstance();

export default function CharacterNotes({ 
  character,
}: Props) {
  const [ping, setPing] = useState(false);
  const [view, setView] = useState("ALL");
  
  const enabled = api.user && (character.owner_id === api.user._id || (character.campaign && character.campaign.owner_id === api.user._id));
  return (
    <Grid container spacing={0} direction="row" className="curved_border bg_black_transp" 
      style={{
        fontSize: "11px"
      }}>
      <Grid size={12}>
        <div className="centered">
          <CenteredMenu
            options={["ALL", "Orgs", "Allies", "Enemies", "Backstory", "Other"]}
            selected={view}
            onSelect={setView}
          />
        </div>
      </Grid>
      { (view === "ALL" || view === "Orgs") && 
        <Grid size={12}>
          <StringBox 
            name="Organizations" 
            disabled={ !enabled }
            value={character.organizations}
            multiline
            onBlur={(changed: string) => {
              character.organizations = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Allies") && 
        <Grid size={12}>
          <StringBox 
            name="Allies" 
            disabled={ !enabled }
            value={character.allies}
            multiline
            onBlur={(changed: string) => {
              character.allies = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Enemies") && 
        <Grid size={12}>
          <StringBox 
            name="Enemies" 
            disabled={ !enabled }
            value={character.enemies}
            multiline
            onBlur={(changed: string) => {
              character.enemies = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Backstory") && 
        <Grid size={12}>
          <StringBox 
            name="Backstory" 
            disabled={ !enabled }
            value={character.backstory}
            multiline
            onBlur={(changed: string) => {
              character.backstory = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
      { (view === "ALL" || view === "Other") && 
        <Grid size={12}>
          <StringBox 
            name="Other" 
            disabled={ !enabled }
            value={character.other_notes}
            multiline
            onBlur={(changed: string) => {
              character.other_notes = changed;
              character.changed();
              setPing(!ping);
            }}
          />
        </Grid>
      }
    </Grid>
  );
}

